<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>
        <v-avatar
          tile
          style="border-radius: 5px !important;"
        >
          <img
            :src="(product && product.avatar ? product.avatar.link : '/img/noImage.png')"
            :alt="productProp.name"
          >
        </v-avatar>
        {{ productProp.name }}
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-container>
      <v-row v-if="product">
        <v-col
          cols="12"
          class="py-0"
          md="4"
        >
          <v-list dense>
            <v-list-item-group
              color="primary"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('code') }} : {{ product.code }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('fixSellPrice') }} : {{ $numberFormat(product.price) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('unit') }} : {{ (product.unit ? product.unit.name : '') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('group') }} : {{ (product.group ? product.group.name : '') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('other-group') }} : {{ (product.cat1 ? product.cat1.name : '') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('category') }} : {{ (product.cat2 ? product.cat2.name : '') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <v-row class="mx-0">
            <v-chip-group class="pa-0 mb-3">
              <v-chip
                label
                outlined
                class="ms-0"
                :color="($vuetify.theme.isDark ? 'white' : 'red')"
              >
                {{ $t('firstCost') }} : {{ (product && product.costs ? $numberFormat(product.costs.first) + ' ' + $store.state.currency.name : '') }}
              </v-chip>
              <v-chip
                label
                outlined
                :color="($vuetify.theme.isDark ? 'white' : 'pink')"
              >
                {{ $t('minCost') }} : {{ (product && product.costs ? $numberFormat(product.costs.min) + ' ' + $store.state.currency.name : '') }}
              </v-chip>
              <v-chip
                label
                outlined
                :color="($vuetify.theme.isDark ? 'white' : 'green')"
              >
                {{ $t('averageCost') }} : {{ (product && product.costs ? $numberFormat(product.costs.average) + ' ' + $store.state.currency.name : '') }}
              </v-chip>
              <v-chip
                label
                outlined
                :color="($vuetify.theme.isDark ? 'white' : 'purple')"
              >
                {{ $t('maxCost') }} : {{ (product && product.costs ? $numberFormat(product.costs.max) + ' ' + $store.state.currency.name : '') }}
              </v-chip>
              <v-chip
                label
                outlined
                :color="($vuetify.theme.isDark ? 'white' : 'deep-purple')"
              >
                {{ $t('lastCost') }} : {{ (product && product.costs ? $numberFormat(product.costs.last) + ' ' + $store.state.currency.name : '') }}
              </v-chip>
            </v-chip-group>
          </v-row>
          <div style="height: 30px">
            {{ $t('productPricing') }}
          </div>
          <v-row class="mx-0">
            <v-simple-table style="width: 100%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      {{ $t('name') }}
                    </th>
                    <th>
                      {{ $t('account-category') }}
                    </th>
                    <th>
                      {{ $t('currency') }}
                    </th>
                    <th>
                      {{ $t('min') }} ({{ $t('count') }})
                    </th>
                    <th>
                      {{ $t('max') }} ({{ $t('count') }})
                    </th>
                    <th>
                      {{ $t('percent') }}
                    </th>
                    <th>
                      {{ $t('price') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(p, i) in product.pricing"
                    :key="i"
                  >
                    <td>{{ p.name }}</td>
                    <td>{{ p.category.name }}</td>
                    <td>{{ p.currency.name }}</td>
                    <td>{{ p.min }}</td>
                    <td>{{ p.max }}</td>
                    <td>{{ p.percent }}</td>
                    <td>{{ $numberFormat((p.price ? p.price : +product.costs[product.price_method] * (p.percent / 100)+ +product.costs[product.price_method]) ) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
          <div
            class="mt-2"
            style="height: 30px"
          >
            {{ $t('lastPurchases') }}
          </div>
          <v-row class="mx-0">
            <v-simple-table style="width: 100%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      {{ $t('date') }}
                    </th>
                    <th>
                      {{ $t('seller') }}
                    </th>
                    <th>
                      {{ $t('currency') }}
                    </th>
                    <th>
                      {{ $t('count') }}
                    </th>
                    <th>
                      {{ $t('fee') }}
                    </th>
                    <th>
                      {{ $t('discount') }}
                    </th>
                    <th>
                      {{ $t('tax') }}
                    </th>
                    <th>
                      {{ $t('sum') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(p, i) in product.purchase"
                    :key="i"
                  >
                    <td>{{ p.head.date }}</td>
                    <td>{{ p.head.customer.name }}</td>
                    <td>{{ p.head.currency.name }}</td>
                    <td>{{ p.count }}</td>
                    <td>{{ $numberFormat(p.fee, 10) }}</td>
                    <td>{{ $numberFormat(p.discount) }}</td>
                    <td>{{ $numberFormat(p.tax) }}</td>
                    <td>{{ $numberFormat((p.fee * p.count) - parseFloat(p.discount) + parseFloat(p.tax)) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'ProductCard',
  props: ['productProp'],
  data () {
    return {
      printType: 'unofficial',
      product: null
    }
  },
  watch: {
    productProp (val) {
      this.product = null
      this.getProductCard(val)
    }
  },
  mounted () {
    if (this.productProp) {
      this.getProductCard(this.productProp)
    }
  },
  methods: {
    getProductCard (item) {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'products', {
        params: {
          getProductCard: 'active',
          id: item.id
        }
      })
        .then(res => {
          res = res.data
          this.product = res
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  }
}
</script>

<style scoped>

</style>
